export const MINIMUM_ACCEPTED_AUDIO_DURATION = 3;
